import { getQueryParam } from '@mi-front/core';

const apiRoot = getQueryParam('API_ROOT') || import.meta.env.VITE_API_ROOT.replace(/\/?$/, '');
const appEnv = import.meta.env.VITE_ENV as 'prod' | 'dev' | 'prod-preview';
const isStorybook = import.meta.env.VITE_ENV === 'storybook';
const disableFeatureTours = import.meta.env.VITE_DISABLE_FEATURE_TOURS === 'true';

/** Unified API gateway host used by api-v2 / api-public-v2 (distinct from logger-api). */
const apiV2Root = (
  import.meta.env.VITE_API_V2_ROOT ||
  (appEnv.startsWith('prod') ? 'https://api.mediainbox.io' : 'https://api-dev.mediainbox.io')
).replace(/\/?$/, '');

export const config = {
  appEnv,
  apiRoot,
  apiV2Root,
  isAppDev: import.meta.env.VITE_ENV === 'dev',
  isNodeDev: import.meta.env.DEV,
  isNodeProd: import.meta.env.PROD,
  isTest: import.meta.env.MODE === 'test',
  appVersion: import.meta.env.VITE_VERSION,
  bugsnagKey: import.meta.env.VITE_BUGSNAG_KEY,
  auth0: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    domain: import.meta.env.VITE_AUTH0_APP_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  },
  isStorybook,
  disableFeatureTours,
  forceLocale: isStorybook ? 'en' : import.meta.env.VITE_LOCALE,
  growthbookClientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  posthogKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  /** Restricted browser key for Google Maps Static API (device card map thumbs). */
  googleMapsStaticApiKey: import.meta.env.VITE_GOOGLE_MAPS_STATIC_API_KEY as string | undefined,
  videoEditorUrl: (() => {
    const url = import.meta.env.VITE_VIDEO_EDITOR_URL;

    if (!url) {
      return appEnv === 'dev' ? 'https://editor-dev.mediainbox.io' : 'https://editor.mediainbox.io';
    }

    return url.replace(/\/?$/, '');
  })(),
  testingUserEmail: 'testing@mediainbox.net',
};
